<template>
  <v-dialog v-model="dialog" persistent width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        dark
        v-bind="attrs"
        v-on="on"
        :disabled="!$permission('129')"
      >
        <v-icon>
          mdi-swap-horizontal
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar dense>
        <v-toolbar-title>
          {{ $t("editWebhook") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-form v-model="form.valid" class="pa-4" @submit.prevent="saveEdit">
        <v-card-text>
          <v-select
            v-model="form.status"
            :items="statusItems"
            dense
            filled
            hide-details
            solo-inverted
            :disabled="!$permission('129')"
          >
          </v-select>
        </v-card-text>
        <v-card-actions class="pt-4 px-4 mt-6 ">
          <v-spacer />
          <v-btn
            color="primary"
            @click="saveEdit"
            :loading="loading"
            :disabled="!form.valid || disableButton || loading"
          >
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate.js";

export default {
  props: {
    infos: {
      status: { type: Boolean },
      webhookId: { type: String },
    },
  },

  data: (self) => ({
    refresh: false,
    dialog: false,
    statusItems: [
      {
        text: self.$t("active"),
        value: "Ativo",
      },
      {
        text: self.$t("inactive"),
        value: "Inativo",
      },
    ],

    form: {
      valid: false,
      status: "",
    },

    rules: {
      required: validate.required,
    },

    loading: false,
  }),

  created() {
    this.form.status = this.infos.status ? "Ativo" : "Inativo";
  },

  watch: {
    dialog(val) {
      if (val) {
        this.form.status = this.infos.status ? "Ativo" : "Inativo";
      }
    },
  },

  computed: {
    disableButton() {
      const oldStatus = this.infos.status ? "Ativo" : "Inativo";

      if (this.form.status === oldStatus) {
        return true;
      }

      return false;
    },
  },

  methods: {
    saveEdit() {
      if (!this.form.valid || this.disableButton || this.loading) {
        return;
      }

      this.loading = true;

      this.$axios
        .post(
          `${this.$prefix()}/WebHook/changeWebHookStatus`,
          this.$formdata({
            id: this.infos.webhookId,
            status_id: this.form.status === "Ativo" ? 1 : 0,
          })
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.dialog = false;

          this.$emit("refresh");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
